import { render, staticRenderFns } from "./Waiting.vue?vue&type=template&id=b8907648&scoped=true&"
import script from "./Waiting.vue?vue&type=script&lang=ts&"
export * from "./Waiting.vue?vue&type=script&lang=ts&"
import style0 from "./Waiting.vue?vue&type=style&index=0&id=b8907648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8907648",
  null
  
)

export default component.exports